import React, { useEffect } from "react";

import OnboardingMain from "0.Mine/0.Components/Onboarding/Container/Onboarding";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function Onboarding() {
  return (
    <DashboardLayout isFullscreen bgColor={"#fff"}>
      <OnboardingMain />
    </DashboardLayout>
  );
}

export default Onboarding;
